import { render } from "./goodsDetail.vue?vue&type=template&id=de5ee874&scoped=true"
import script from "./goodsDetail.vue?vue&type=script&lang=js"
export * from "./goodsDetail.vue?vue&type=script&lang=js"

import "./goodsDetail.vue?vue&type=style&index=0&id=de5ee874&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de5ee874"]])

export default __exports__